import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Clock, Gem, Box, ChevronRight } from "lucide-react";
import { Card, CardContent } from "../ui/card";

export function DashboardQuickStats({ peakActivityHour, bestCustomer, stockValue, primaryColor, devise, onStockClick }) {
  const navigate = useNavigate();
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.7 }}>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {/* Pic d'activité */}
        <Card className="border-border/50 bg-gradient-to-br from-card to-secondary/20">
          <CardContent className="p-3 md:p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2 mb-1.5 md:mb-2">
                  <span className="text-base md:text-lg">&#128336;</span>
                  <span className="text-xs md:text-sm font-medium text-muted-foreground">Pic d'activité</span>
                </div>
                <p className="text-lg md:text-xl font-bold">{peakActivityHour}</p>
                <p className="text-xs text-muted-foreground mt-1 hidden sm:block">Votre meilleure tranche horaire</p>
              </div>
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center"
                style={{ backgroundColor: `${primaryColor}15` }}>
                <Clock className="w-4 h-4 md:w-5 md:h-5" style={{ color: primaryColor }} />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Meilleure cliente */}
        <Card className={`border-border/50 bg-gradient-to-br from-card to-secondary/20 ${bestCustomer ? 'cursor-pointer hover:shadow-md transition-all' : ''}`}
          onClick={() => bestCustomer && navigate('/customers')}>
          <CardContent className="p-3 md:p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2 mb-1.5 md:mb-2">
                  <span className="text-base md:text-lg">&#128142;</span>
                  <span className="text-xs md:text-sm font-medium text-muted-foreground">Meilleure cliente</span>
                </div>
                {bestCustomer ? (
                  <>
                    <p className="text-lg md:text-xl font-bold">{bestCustomer.name}</p>
                    <p className="text-xs text-muted-foreground mt-1 hidden sm:block">{bestCustomer.purchases} achats ce mois</p>
                  </>
                ) : (
                  <>
                    <p className="text-base md:text-lg font-medium text-muted-foreground">—</p>
                    <p className="text-xs text-muted-foreground mt-1 hidden sm:block">Aucune donnée disponible</p>
                  </>
                )}
              </div>
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center" style={{ backgroundColor: '#EC489915' }}>
                <Gem className="w-4 h-4 md:w-5 md:h-5" style={{ color: '#EC4899' }} />
              </div>
            </div>
            {bestCustomer && (
              <div className="flex items-center justify-end mt-2">
                <span className="text-xs text-muted-foreground group-hover:text-primary">Voir la fiche <ChevronRight className="w-3 h-3 inline" /></span>
              </div>
            )}
          </CardContent>
        </Card>

        {/* Valeur du stock */}
        <Card className="border-border/50 bg-gradient-to-br from-card to-secondary/20 cursor-pointer hover:shadow-md transition-all"
          onClick={onStockClick} data-testid="stock-value-card">
          <CardContent className="p-3 md:p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2 mb-1.5 md:mb-2">
                  <span className="text-base md:text-lg">&#128230;</span>
                  <span className="text-xs md:text-sm font-medium text-muted-foreground">Valeur du stock</span>
                </div>
                <p className="text-lg md:text-xl font-bold" style={{ color: primaryColor }}>
                  {stockValue.value.toLocaleString('fr-FR')} {devise}
                </p>
                <p className="text-xs text-muted-foreground mt-1 hidden sm:block">{stockValue.itemCount} articles en stock</p>
              </div>
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center" style={{ backgroundColor: '#8B5CF615' }}>
                <Box className="w-4 h-4 md:w-5 md:h-5" style={{ color: '#8B5CF6' }} />
              </div>
            </div>
            <div className="flex items-center justify-end mt-2">
              <span className="text-xs text-muted-foreground">Voir le stock <ChevronRight className="w-3 h-3 inline" /></span>
            </div>
          </CardContent>
        </Card>
      </div>
    </motion.div>
  );
}
